"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEdgeSeparator = void 0;
const removeEdgeSeparator = ({ separator }, idx, items) => !(separator && (idx === 0 || items.length - 1 === idx));
exports.removeEdgeSeparator = removeEdgeSeparator;
//# sourceMappingURL=removeEdgeSeparator.js.map